const version = () => ({
    showWhatsNew: true,
    NUMBER: '4.5.0',
});

export default version();
